var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.72C0 .77.794 0 1.774 0h20.452C23.206 0 24 .77 24 1.72V22.28c0 .95-.794 1.719-1.774 1.719H1.774C.794 24 0 23.23 0 22.281V1.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.688 7H6.313C5.574 7 5 7.573 5 8.25v7.5c0 .703.574 1.25 1.313 1.25h11.375c.71 0 1.312-.547 1.312-1.25v-7.5C19 7.573 18.398 7 17.687 7Zm0 1.25v1.068c-.63.495-1.614 1.224-3.692 2.786-.465.339-1.367 1.172-1.996 1.146-.656.026-1.559-.807-2.023-1.146-2.079-1.562-3.063-2.291-3.665-2.786V8.25h11.375Zm-11.375 7.5v-4.818c.601.469 1.503 1.146 2.843 2.162.602.443 1.668 1.432 2.844 1.406 1.148.026 2.188-.963 2.816-1.406a443.45 443.45 0 0 1 2.871-2.162v4.818H6.313Z",
    fill: "var(--bg-color)"
  })));
};
export { SvgEmail as ReactComponent };
export default __webpack_public_path__ + "f3143c5333382f1fc5efc392295fcd5a.svg";